module.exports = __webpack_public_path__ + "assets/fillers.1404bd3b.svg";